/**
 * The responsbility of this component is to display the google powered logo at the bottom right corner of the map or any other component when google map is used for copyright purposes.
 */

import React from 'react';
import { useTheme } from '@mui/material';

function GooglePoweredLogo() {
    const theme = useTheme();
    return (
        <img
            src={
                theme.palette.mode === 'dark'
                    ? 'https://maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-non-white3_hdpi.png'
                    : 'https://maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-white3_hdpi.png'
            }
            alt="Powered by Google"
            width="120"
        />
    );
}

export default GooglePoweredLogo;
